export { default as SentryErrorBoundary } from './SentryErrorBoundary';
